import React from 'react'

 function About() {
    return (
        <React.Fragment>
            <h1>About</h1>
            <p>This is my Todolist app v1.0.0, just my first react app <br/>
                to keep tabs of my daily activities and to build my knowlegde of
                React.js 
            </p>
        </React.Fragment>
    )
}

export default About